



































import Vue from "vue";
import Component from "vue-class-component";
import { dateRules, required } from "@/utils/validation";
import { Prop, Model, Emit } from "vue-property-decorator";

@Component({})
export class DateInput extends Vue {
  private menu: boolean = false;
  private localValue: string = '';

  @Prop({default: ""})
  public label!: string;

  @Prop({default: true})
  public max!: boolean;

  @Prop()
  public rules?: any[];

  @Prop()
  @Model("change")
  public value!: string;

  mounted() {
    this.localValue = `${this.value || ''}`;
  }

  get localRules() {
    return [
      ...dateRules,
      ...(this.rules || []),
    ];
  }

  dateValue() {
    if (!this.isValidDate(this.localValue)) {
      return this.dateToString(new Date());
    }

    return this.localValue;
  }

  onPickerChange(date: Date) {
    this.$emit('change', this.localValue = this.dateToString(date));
  }

  onClear() {
    this.$emit('change', this.localValue = '');
  }

  onInput(value: string) {
    if (!!value && !/^[0-9-]+$/.test(value)) {
      this.localValue = value = value.replace(/\./g, '-').replace(/[^0-9-]/gi, '');
    }
    this.localValue = value;
  }

  onBlur() {
    if (!!this.localValue && this.isValidDate(this.localValue)) {
      this.$emit('change', this.localValue);
    }
  }

  private dateToString(value: Date) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.toISOString().substr(0, 10);
  }

  private isValidDate(date: string) {
    return dateRules.filter(r => r(date) !== true).length == 0;
  }
}

export default DateInput;
